<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Settings"
            bc3="Update"
            path="settings"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="name-icon">Type</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <div class="input-group-prepend">-->
<!--                                <span class="input-group-text"-->
<!--                                  ><i class="far fa-edit"></i-->
<!--                                ></span>-->
<!--                              </div>-->
<!--                              <input-->
<!--                                type="text"-->
<!--                                v-model="type"-->
<!--                                id="name-icon"-->
<!--                                class="form-control"-->
<!--                                :class="-->
<!--                                  errorBag.has('type') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                                name="type"-->
<!--                                placeholder="Type"-->
<!--                                v-validate="'required'"-->
<!--                              />-->
<!--                              <small-->
<!--                                v-show="errorBag.has('type')"-->
<!--                                class="invalid-feedback"-->
<!--                                >{{ "*" + errorBag.first("type") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Value</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                v-model="value"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('value') ? 'is-invalid' : ''
                                "
                                name="value"
                                placeholder="Value"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('value')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("value") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-9 offset-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="$emit('back')"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon, Edit3Icon } from "vue-feather-icons";

export default {
  components: {
    CommandIcon,
    Edit3Icon
  },
  mounted() {
    let settingsUpdateData = this.$store.getters.getByKey("settingsUpdate");
    if (settingsUpdateData) {
      this.index = settingsUpdateData.index;
      this.id = settingsUpdateData.id;
      this.name = settingsUpdateData.name;
      // this.type = settingsUpdateData.row.type;
      this.value = settingsUpdateData.value;
    }
  },
  data() {
    return {
      id: "",
      index: "",
      name: "",
      loading: false,
      size: "10px",
      type: "",
      value: ""
    };
  },
  methods: {
    Back() {
      this.$router.push({ name: "settings" });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          // let data = new FormData();
          // data.append("application", "android");
          // data.append("applicationVersion", "1.33");
          // data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          // data.append("deviceDetail", "android s4 etc");
          // data.append("latitude", "");
          // data.append("longitude", "");
          // data.append("id", this.id);
          // data.append("name", this.name);
          // data.append("type", this.type);
          // data.append("value", this.value);

          let data = {
            id:this.id,
            name:this.name,
            // type:this.type,
            value:this.value,
          }

          this.makeRequest("post", "v1/update-settings", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("settingsUpdate");
                    let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                    let rowProp = {
                      ...storeData,
                      ...responseData
                    }
                    rawdata[storeData.idx] = rowProp
                    this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                    this.$emit('back')
                    return
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

